import { NgModule } from '@angular/core';
import { PageTitleComponent } from '@app/shared/ui/pagetitle/page-title.component';
import { CommonModule } from '@angular/common';
import { UiElementModule } from '@agilent/ui-element';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationModule } from '@agilent/ui-element';
import { AgTimeAgoModule } from '@app/shared/pipes/ag-time-ago/ag-time-ago.module';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { AgMacAddressPipe } from '@app/shared/pipes/ag-mac-address.pipe';
import { NavLinkComponent } from '@app/shared/ui/nav-link/nav-link.component';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { AgIconWrapperComponent } from '@app/shared/ui/ag-icon-wrapper.component';
import { GridComponent } from '@app/shared/ui/grid/grid.component';
import { ActivityLogGridComponent } from '@app/shared/ui/activity-log-grid/activity-log-grid.component'
import { AgGridModule } from 'ag-grid-angular';
import { AppUserReasonFormComponent } from '@app/shared/app-user-reason-form.component';
import { PlaceholderAnimationComponent } from '@app/shared/placeholder-animation.component';
import { AppInputWrapperComponent } from '@app/shared/app-input-wrapper.component';
import { AppDropdownWrapperComponent } from '@app/shared/app-dropdown-wrapper.component';
import 'ag-grid-enterprise';


@NgModule({
    declarations: [
        PageTitleComponent,
        AgMacAddressPipe,
        NavLinkComponent,
        AgIconWrapperComponent,
        GridComponent,
        ActivityLogGridComponent,
        AppUserReasonFormComponent,
        PlaceholderAnimationComponent,
        AppInputWrapperComponent,
        AppDropdownWrapperComponent
    ],
    imports: [
        CommonModule,
        UiElementModule,
        RouterModule,
        NgxMaskModule,
        AgGridModule
    ],
    exports: [
        PageTitleComponent,
        NavLinkComponent,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        UiElementModule,
        AgTimeAgoModule,
        NgbPaginationModule,
        NotificationModule,
        AgMacAddressPipe,
        NgxMaskModule,
        AgIconWrapperComponent,
        GridComponent,
        ActivityLogGridComponent,
        AppUserReasonFormComponent,
        PlaceholderAnimationComponent,
        AppInputWrapperComponent,
        AppDropdownWrapperComponent
    ]
})

export class SharedUiModule {

}
